import React from 'react'
import { AlgoliaPlacesState, IAlgoliaHit } from './store/State'
import { AlgoliaPlacesAction } from './store/Actions'
import { IAlgoliaResponse } from './Interface'
import { Http } from 'lib'
import { setIsLoading, setOptions, setSearchTerm, setIsSelectorOpen } from './store/Actions'
import apiUrlsAddresses from '../../config/constants/api-urls-addresses'
import { IPlaceOption } from 'types/IPlaceOption'

export default class AlgoliaPlacesService {
  static async requestAlgoliaPlaces(input: string): Promise<[IAlgoliaResponse | null, number, string | null]> {
    return Http.get<IAlgoliaResponse>(apiUrlsAddresses.algolia(input))
  }

  static parseAlgoliaHit(hits: IAlgoliaHit[]): IPlaceOption[] {
    return hits.map(hit => ({
      id: hit.objectID,
      city: hit.locale_names ? hit.locale_names[0] : '',
      state: hit.administrative ? hit.administrative[0] : '',
      country: hit.country || '',
      countryCode: hit.country_code
    }))
  }

  static async loadOptions(dispatch: React.Dispatch<AlgoliaPlacesAction>, searchTerm: string): Promise<void> {
    dispatch(setIsLoading(true))

    const [response, , error] = await AlgoliaPlacesService.requestAlgoliaPlaces(searchTerm)

    if (Boolean(error)) {
      dispatch(setIsLoading(false))
      throw new Error(error)
    } else {
      const parsedOptions = AlgoliaPlacesService.parseAlgoliaHit(response.hits)
      dispatch(setOptions(parsedOptions))
    }

    dispatch(setIsLoading(false))
  }

  static onSearchTermChanged(state: AlgoliaPlacesState, dispatch: React.Dispatch<AlgoliaPlacesAction>) {
    return (term: string) => {
      if (term !== state.searchTerm) {
        dispatch(setSearchTerm(term))
      }
    }
  }

  static onSetIsSelectorOpen(state: AlgoliaPlacesState, dispatch: React.Dispatch<AlgoliaPlacesAction>) {
    return (isSelectorOpen: boolean) => {
      if (isSelectorOpen !== state.isSelectorOpen) {
        dispatch(setIsSelectorOpen(isSelectorOpen))
      }
    }
  }
}
